export const BASE_URL = 'document-assembler';
export const TEMPLATE_CATEGORIES_URL = `${BASE_URL}/template-categories`;
export const TEMPLATES_URL = `${BASE_URL}/templates`;
export const GENERATIONS_URL = `${BASE_URL}/generations`;

export const templateVersionsUrl = (templateId: string) =>
  `${TEMPLATES_URL}/${templateId}/versions`;

export const DOCUMENT_ASSEMBLER_LIMITS = {
  maxTemplateFileBytes: 25 * 1024 * 1024,
  maxKeyLength: 64,
  maxNameLength: 200,
  maxDescriptionLength: 2000,
  maxAuthorGuidanceLength: 20_000,
} as const;

export const DOCUMENT_ASSEMBLER_KEY_FORMAT_REGEX =
  /^[a-z0-9]+(?:[-._][a-z0-9]+)*$/;

export const DOCUMENT_ASSEMBLER_TEMPLATE_VERSION_NOT_USABLE_ERROR_CODE =
  'DOCUMENT_ASSEMBLER_TEMPLATE_VERSION_NOT_USABLE';
